module.exports = __webpack_public_path__ + "img/image4.ab3f0472.jpg";